/**
 * Notification preferences + verification API client.
 *
 * All four functions go through the BFF (`harmoniq-public-bff`),
 * which forwards bearer tokens to `harmoniq-services-auth`.
 * `verify` is the only one that's public — it doesn't need a
 * logged-in session because the JWT in `token` IS the credential.
 */
import api from "./api";

const notificationService = {
  /** GET /users/me/notification-preferences — returns master + 3 granular toggles + email_verified */
  getPreferences: () => api.get("/users/me/notification-preferences"),

  /**
   * PATCH /users/me/notification-preferences — partial update.
   * Returns 412 PRECONDITION FAILED from auth (forwarded by the BFF)
   * when the caller tries to enable any toggle while
   * email_verified is false. The UI uses that signal to render the
   * verify banner.
   */
  updatePreferences: (patch) =>
    api.patch("/users/me/notification-preferences", patch),

  /**
   * POST /users/me/email/send-verification — fires a verification
   * email to the current user. Returns 204 on SENT or auth-side
   * suppression (suppression-list membership is intentionally not
   * leaked to the UI).
   */
  sendVerification: () => api.post("/users/me/email/send-verification"),

  /**
   * POST /auth/email/verify — public endpoint, validates a token
   * from a clicked email link. Returns {status: "success"|"invalid"}.
   * Used by the verify-email landing page.
   */
  verify: (token) => api.post("/auth/email/verify", { token }),
};

export default notificationService;
